import { ExternalCategory, ExternalProductsResponse } from 'common/types/entities/api/External'
import { axios } from 'common/utils'
import { ExternalParams } from 'common/ducks/external/externalProducts'

export async function fetchGrafolioCategories(): Promise<ExternalCategory[]> {
  const response = await axios.get('/v1/external/grafolio/categories', {})
  return response && response.data
}

export async function fetchGrafolioProducts(params: ExternalParams): Promise<ExternalProductsResponse> {
  const response = await axios.get('/v1/external/grafolio', { params })
  return response && response.data
}
